import { Box, Button } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { store } from '../../../../redux/store'
import {
    updateAttributeValues,
    updateValuesForPayload,
} from '../../../../utils/EntityAttributesUtils'
import Fields from '../../../Common/Fields'
import {
    AttributeType,
    EntityStatus,
    InsuranceAttributes,
    InsuranceStatus,
    ShipmentAttributes,
} from '../../../../constants/constants'
import { IAttribute2 } from '../../../DTStudio/interfaces'
import { validateAttributes } from '../../../../utils/attributeValidations'
import {
    IPostInsuranceActionData,
    onSaveEntityInstance,
    postInsuranceAction,
} from '../../../../services/entityServices'
import { useTranslation } from 'react-i18next'
import { fetchResolvedOrgDataOrgId } from '../../../../services/orgServices'
import { updateLoader } from '../../../../redux/slices/loaderSlice'

const insuranceAttributesOrder = [
    // 'Id',
    // 'licenseDuration',
    // 'insuranceStatus',
    // 'pdfCertificateField',
    // 'separator', //A Line Breaker Attribute
    'systemPolicyNumber',
    'primaryAssuredCompanyCode',
    'separator', //A Line Breaker Attribute
    'separator', //A Line Breaker Attribute
    'assuredName',
    'countryIso',
    'separator', //A Line Breaker Attribute
    'separator', //A Line Breaker Attribute
    // 'quoteReferenceId',
    'insuredValue',
    'departureDate',
    'origin',
    'destination',
    'conveyanceClientCode',
    'loading',
    'discharge',
    // 'quoteExpiryDate',
    // 'quotePremiumAmount',
    'quoteCertificateNumber',
    'legalAssured',
    'commodityClientCode',
    'coverageOptionClientCode',
    'shipment',
    'packingMethodClientCode',
    'descriptionOfCargo',
]
const separator: IAttribute2 = {
    id: 'separator',
    name: '6405e119-3ee0-4f9d-aaf0-d1b814bb2b96',
    dataType: 'separator',
    attributeType: 'Static',
    range: ' ',
    required: false,
    sequence: 1,
    defaultValue: '',
    isSearchable: false,
    value: null,
    metadata: {
        Array: false,
        Hidden: false,
        Mappable: false,
        Chartable: false,
        'View-Only': false,
        Searchable: false,
        TimeSeries: false,
        Displayable: false,
        Superviewer: false,
    },
    templateMetaData: undefined,
    unit: '',
    disabled: false,
    hide: false,
    readOnly: true,
    uid: '',
    isDisplayNameUpdated: false,
    isPropertiesUpdated: false,
    list: [],
} as IAttribute2
export interface IAddInsuranceProps {
    insuranceEntityTemplateId: string
    insuranceInstanceId: string
    shipmentInstanceId: string
    insuranceAttributesData: IAttribute2[]
    orgId: string
    readOnly: boolean
    setReadOnly: (k: boolean) => void
    reload: () => void
}
const AddorEditInsurance = (props: IAddInsuranceProps): ReactElement => {
    const { t } = useTranslation()
    const {
        insuranceEntityTemplateId,
        insuranceInstanceId,
        shipmentInstanceId,
        insuranceAttributesData,
        orgId,
        readOnly,
        setReadOnly,
        reload,
    } = props
    const org = useAppSelector((state) => state.org.org)
    const entityViewData = useAppSelector(
        (state) => state.entityInstanceView.entityData,
    )
    const { selfEntityAttributeData } = entityViewData
    const createSeparator = (): IAttribute2 => ({
        ...separator,
    })
    const dispatch = useAppDispatch()
    const [insuranceAttributes, setInsuranceAttributes] = useState<
        IAttribute2[]
    >([])
    useEffect(() => {
        const getInsuranceAttributes = async () => {
            // dispatch(updateLoader(true))
            const orgData = org
                ? await fetchResolvedOrgDataOrgId(
                      org?.id || '',
                      'Shipper',
                      'orgType',
                  )
                : null

            const orgInsurancePolicyData =
                orgData?.preferences?.insuranceDetails
            const insurancePolicyNumber =
                insuranceAttributesData?.find(
                    (i) => i.id === InsuranceAttributes.SystemPolicyNumber,
                )?.value || ''
            const insuranceStatus =
                insuranceAttributesData?.find(
                    (i) => i.id === InsuranceAttributes.InsuranceStatus,
                )?.value || ''
            const conveyanceClientCode =
                insuranceAttributesData?.find(
                    (i) => i.id === InsuranceAttributes.ConveyanceClientCode,
                )?.value || ''

            const updatedInsuranceAttributes: IAttribute2[] =
                updateAttributeValues(
                    insuranceAttributesData,
                    store,
                    !!insuranceInstanceId,
                )
            const attributeMap = new Map(
                updatedInsuranceAttributes.map((attr) => [attr.id, attr]),
            )
            const orderedInsuranceAttributes = insuranceAttributesOrder.reduce<
                IAttribute2[]
            >((acc, id) => {
                if (id === 'separator') {
                    if (acc[acc.length - 1]?.id !== 'separator') {
                        acc.push(createSeparator())
                    }
                } else {
                    const attr = attributeMap.get(id)
                    if (attr) {
                        acc.push({
                            ...attr,
                            width: '30%',
                            value: insuranceInstanceId
                                ? attr.value
                                : attr.defaultValue,
                        })
                    }
                }
                return acc
            }, [])
            const shipmentOriginValue =
                selfEntityAttributeData.attributes?.find(
                    (i) =>
                        i.id === ShipmentAttributes.OriginLocationAttributeId,
                )?.value || ''
            const shipmentDestinationValue =
                selfEntityAttributeData.attributes?.find(
                    (i) =>
                        i.id ===
                        ShipmentAttributes.DestinationLocationAttributeId,
                )?.value || ''
            const updateFields = orderedInsuranceAttributes?.map((i) => {
                if (i.id === InsuranceAttributes.Shipment) {
                    const obj = { ...i }
                    obj.value = insuranceInstanceId
                        ? obj.value
                        : shipmentInstanceId
                    return obj
                } else if (i.id === InsuranceAttributes.Origin) {
                    const obj = { ...i }
                    obj.value = insuranceInstanceId
                        ? obj.value
                        : shipmentOriginValue
                    obj.disabled = true
                    return obj
                } else if (i.id === InsuranceAttributes.Destination) {
                    const obj = { ...i }
                    obj.value = insuranceInstanceId
                        ? obj.value
                        : shipmentDestinationValue
                    obj.disabled = true
                    return obj
                } else if (i.id === InsuranceAttributes.SystemPolicyNumber) {
                    const obj = { ...i }
                    obj.dataType = AttributeType.SELECT
                    obj.list = orgInsurancePolicyData?.map((i) => {
                        return {
                            ...i,
                            ...{
                                id: i.systemPolicyNumber,
                                name: i.systemPolicyNumber,
                            },
                        }
                    })
                    obj.value = insuranceInstanceId
                        ? obj.value
                        : orgInsurancePolicyData?.[0]?.systemPolicyNumber || '' //selecting first value
                    obj.hide = true
                    obj.disabled = !!insuranceInstanceId
                    return obj
                } else if (
                    i.id === InsuranceAttributes.PrimaryAssuredCompanyCode
                ) {
                    let PrimaryAssuredCompanyCodeList = []
                    if (insurancePolicyNumber) {
                        PrimaryAssuredCompanyCodeList =
                            orgInsurancePolicyData?.find(
                                (i) =>
                                    i.systemPolicyNumber ===
                                    insurancePolicyNumber,
                            )?.primaryAssuredCompanyCode || []
                    } else {
                        PrimaryAssuredCompanyCodeList =
                            orgInsurancePolicyData?.[0]
                                ?.primaryAssuredCompanyCode || []
                    }

                    const obj = { ...i }
                    obj.dataType = AttributeType.SELECT
                    obj.list =
                        PrimaryAssuredCompanyCodeList?.map((i) => {
                            return { id: i, name: i }
                        }) || []
                    obj.value = insuranceInstanceId
                        ? obj.value
                        : PrimaryAssuredCompanyCodeList?.[0] || ''
                    obj.hide = true
                    return obj
                } else if (i.id === InsuranceAttributes.QuoteExpiryDate) {
                    const obj = { ...i }
                    obj.hide =
                        insuranceStatus === InsuranceStatus.ACCEPT ||
                        insuranceStatus === InsuranceStatus.REJECT
                    return obj
                } else if (
                    i.id === InsuranceAttributes.Loading ||
                    i.id === InsuranceAttributes.Discharge
                ) {
                    const obj = { ...i }
                    obj.required = conveyanceClientCode === 'OCE'
                    obj.disabled = conveyanceClientCode !== 'OCE'
                    return obj
                } else if (i.id === InsuranceAttributes.InsuredValue) {
                    const obj = { ...i }
                    obj.inputType = 'number'
                    return obj
                } else {
                    return i
                }
            })
            setInsuranceAttributes(updateFields)
            // dispatch(updateLoader(false))
        }
        if (
            insuranceEntityTemplateId &&
            selfEntityAttributeData.attributes &&
            orgId
        ) {
            getInsuranceAttributes()
        }
    }, [
        insuranceEntityTemplateId,
        insuranceInstanceId,
        orgId,
        org,
        selfEntityAttributeData.attributes,
        shipmentInstanceId,
        insuranceAttributesData,
        dispatch,
    ])

    const onChangeFields = (
        id: string,
        value: any,
        key?: string,
        otherId?: string,
        otherValue?: any,
        otherKey?: string,
    ) => {
        let updateInsuranceAttributes = insuranceAttributes?.map((i) => {
            if (i.id === id) {
                const obj = { ...i }
                ;(obj as any)[key ?? 'value'] = value
                ;(obj as any)['errorMessage'] = ''
                return obj // Update the field value within the step
            } else if (otherId && i.id === otherId) {
                const obj = { ...i }
                ;(obj as any)[otherKey ?? 'value'] = otherValue
                ;(obj as any)['errorMessage'] = ''
                return obj
            } else {
                return i
            }
        })

        if (id === InsuranceAttributes.SystemPolicyNumber) {
            const orgInsurancePolicyData = updateInsuranceAttributes.find(
                (i) => i.id === InsuranceAttributes.SystemPolicyNumber,
            )?.list
            updateInsuranceAttributes = updateInsuranceAttributes.map((i) => {
                if (i.id === InsuranceAttributes.PrimaryAssuredCompanyCode) {
                    const PrimaryAssuredCompanyCodeList =
                        orgInsurancePolicyData?.find(
                            (i: any) => i.systemPolicyNumber === value,
                        )?.primaryAssuredCompanyCode || []
                    const obj = { ...i }
                    obj.list =
                        PrimaryAssuredCompanyCodeList?.map((i: string) => {
                            return { id: i, name: i }
                        }) || []
                    obj.value = ''
                    return obj
                } else {
                    return i
                }
            })
        } else if (id === InsuranceAttributes.ConveyanceClientCode) {
            updateInsuranceAttributes = updateInsuranceAttributes.map((i) => {
                if (
                    i.id === InsuranceAttributes.Loading ||
                    i.id === InsuranceAttributes.Discharge
                ) {
                    const obj = { ...i }
                    obj.required = value === 'OCE'
                    obj.errorMessage = value === 'OCE' ? obj.errorMessage : ''
                    obj.disabled = value !== 'OCE'
                    obj.value = ''
                    return obj
                } else {
                    return i
                }
            })
        }
        setInsuranceAttributes(updateInsuranceAttributes)
    }

    const onClickSave = (sendRequest: boolean = false) => {
        const { isValidated, updatedFields: updatedInsuranceAttributes } =
            validateAttributes(insuranceAttributes || [])
        if (isValidated) {
            onSaveInstance(
                updatedInsuranceAttributes,
                EntityStatus.ACTIVE,
                sendRequest,
            )
        } else {
            setInsuranceAttributes(updatedInsuranceAttributes)
        }
    }

    const onSaveInstance = async (
        insuranceAttributes: any,
        status: string,
        sendRequest: boolean,
    ) => {
        dispatch(updateLoader(true))
        let updatedFields = JSON.parse(JSON.stringify(insuranceAttributes))
        updatedFields = updateValuesForPayload(updatedFields)

        const savedInstanceResult = await onSaveEntityInstance(
            updatedFields,
            orgId,
            insuranceEntityTemplateId || '',
            insuranceInstanceId || '0',
            status,
            orgId,
        )
        if (savedInstanceResult.type === 'success') {
            if (sendRequest) {
                const insuranceActionData: IPostInsuranceActionData = {
                    shipmentEntityId: shipmentInstanceId,
                    action: 'Request For Quote',
                }
                await postInsuranceAction(insuranceActionData, orgId)
            }
        }
        reload()
        // dispatch(updateLoader(false))
    }
    return (
        <Box sx={{ width: '100%', flexGrow: 1 }}>
            {insuranceAttributes?.length ? (
                <>
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        width="100%"
                    >
                        <Fields
                            fields={insuranceAttributes}
                            onChangeFields={onChangeFields}
                            onClickMap={() => {}}
                            disabled={readOnly}
                            fieldMinWidth="150px"
                            fieldMaxWidth="calc(33% - 20px)"
                        />{' '}
                    </Box>
                    {!readOnly ? (
                        <Box
                            display="flex"
                            flexWrap="wrap"
                            alignItems="flex-start"
                            justifyContent="flex-end"
                            width="100%"
                            marginBottom="20px"
                        >
                            {insuranceInstanceId && (
                                <Button
                                    id="cancel-insurance-instance"
                                    onClick={() => setReadOnly(true)}
                                    sx={{
                                        fontSize: '12px',
                                        padding: '7px 20px',
                                        marginRight: '15px',
                                    }}
                                    variant="outlined"
                                >
                                    {t('cancel')}
                                </Button>
                            )}

                            <Button
                                id="save-insurance-instance"
                                onClick={() => onClickSave(false)}
                                sx={{
                                    fontSize: '12px',
                                    padding: '7px 20px',
                                    marginRight: '15px',
                                }}
                                variant="outlined"
                            >
                                {insuranceInstanceId ? t('update') : t('save')}
                            </Button>
                            <Button
                                id="save-insurance-and-request-quote"
                                onClick={() => onClickSave(true)}
                                sx={{
                                    color: '#fff',
                                    fontSize: '12px',
                                    padding: '7px 20px',
                                }}
                                variant="contained"
                            >
                                {t('requestForQuote')}
                            </Button>
                        </Box>
                    ) : null}
                </>
            ) : null}
        </Box>
    )
}

export default AddorEditInsurance
